import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { fifthFlowsActions } from 'features/fifthFlows';

const useFifthFlows = () => {
  const dispatch = useDispatch();
  const getFifthFlow = useCallback(() => dispatch(fifthFlowsActions.getFifthFlow()), [dispatch]);
  const createFifthFlow = useCallback(fifth_flow => dispatch(fifthFlowsActions.createFifthFlow(fifth_flow)), [dispatch]);
  const updateFifthFlow = useCallback(fifth_flow => dispatch(fifthFlowsActions.updateFifthFlow(fifth_flow)), [dispatch]);
  const deleteFifthFlow = useCallback(() => dispatch(fifthFlowsActions.deleteFifthFlow()), [dispatch]);
  const clearLocalActiveFifthFlow = useCallback(() => dispatch(fifthFlowsActions.clearLocalActiveFifthFlow()), [dispatch]);

  return {
    getFifthFlow,
    createFifthFlow,
    updateFifthFlow,
    deleteFifthFlow,
    clearLocalActiveFifthFlow
  };
};

export default useFifthFlows;